import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Badge from '@material-ui/core/Badge'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'

import settings from 'settings'
import selectors from 'store/selectors'
import routerActions from 'store/modules/router'
import quoteActions from 'store/modules/quote'

const FolderIcon = settings.icons.folder
const SaveIcon = settings.icons.save

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  sidebar: {
    minWidth: '300px',
    flexGrow: 0,
    position: 'relative',
  },
  paper: {
    position: 'absolute',
    left: '0px',
    top: '0px',
    zIndex: -1,
    width: '100%',
    height: '100%',
    borderRight: '1px solid #ccc',
  },
  listContainer: {
    position: 'relative',
    height: '100%',
    
    display: 'flex',
    flexDirection: 'column',
  },
  list: {
    flexGrow: 1,
    overflowY: 'auto',
  },
  listDivider: {
    flexGrow: 0,
  },
  bottomButtons: {
    flexGrow: 0,
    textAlign: 'center',
  },
  bottomButtonIcon: {
    marginLeft: theme.spacing(),
  },
  listItem: {
    paddingLeft: '0px',
    paddingTop: '0px',
    paddingBottom: '0px',
  },
  sectionListItem: {
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
    marginBottom: theme.spacing(),
  },
  sectionDivider: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
  },
  listIcon: {
    minWidth: '30px',
    '& > svg': {
      fontSize: '22px',
    },
  },
  listIconCurrent: {
    '& > svg': {
      color: theme.palette.primary.main,
    },
  },
  listText: {
    paddingLeft: theme.spacing(),
    '& > span': {
      fontSize: '0.95em',
    },
  },
  listTextBold: {
    '& > span': {
      fontWeight: 'bold',
    },
  },
  listTextCurrent: {
    '& > span': {
      color: theme.palette.primary.main,
    },
  },
  content: {
    flexGrow: 1,
    height: '100%',
    //overflowY: 'auto',
  },
  margin: {
    margin: theme.spacing(2),
  },
}))

const QuoteTree = ({
  children,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const route = useSelector(selectors.router.route)
  const quote = useSelector(selectors.quote.collection.item)
  const queryParams = useSelector(selectors.router.params)
  const tree = useSelector(selectors.quote.tree)
  const currentFolder = useSelector(selectors.quote.currentFolder)
  const changes = useSelector(selectors.quote.changes)

  const quoteid = queryParams.id
  const folderid = queryParams.folderid

  const onViewFolder = (id) => dispatch(quoteActions.viewFolder(id))
  const onSave = () => dispatch(quoteActions.saveQuote())

  const getListItem = ({
    id,
    title,
    depth = 0,
  }) => {
    const isCurrent = folderid == id
    return (
      <ListItem 
        button 
        key={ id }
        className={ classes.listItem }
        onClick={ () => onViewFolder(id) }
      >
        <div style={{
          marginLeft: depth * 14 + 'px',
        }} />
        <ListItemIcon className={ `${classes.listIcon} ${isCurrent ? classes.listIconCurrent : '' }` }>
          <FolderIcon />
        </ListItemIcon>
        <ListItemText 
          className={ `${classes.listText} ${ isCurrent ? classes.listTextBold : ''} ${isCurrent ? classes.listTextCurrent : ''}` }
          primary={ title }
        />
      </ListItem>
    )
  }

  const renderItem = ({
    item,
    depth = 1,
  }) => {
    
    const results = [getListItem({
      id: item.id,
      title: item.resource.name,
      depth,
    })]

    const childIds = tree.children[item.id] || []

    const childItems = childIds
      .map(childId => tree.items[childId])
      .filter(item => item.type == 'folder')
      .map(item => renderItem({
        item,
        depth: depth + 1,
      }))
    return results.concat(childItems)
  }


  if(!quote) return null

  const rootItem = {
    id: 'root',
    resource: {
      name: quote.name,
    }
  }

  return (
    <div className={ classes.root }>
      <div className={ classes.sidebar }>
        <Paper
          className={ classes.paper }
          square
          elevation={ 0 }
        />
        <div className={ classes.listContainer }>
          <div className={ classes.list }>
            <List component="nav">
              { 
                renderItem({
                  item: rootItem
                })
              }
            </List>
          </div>
          <div className={ classes.listDivider }>
            <Divider />
          </div>
          <div className={ classes.bottomButtons }>
            <Badge
              color="secondary"
              badgeContent={ changes }
              className={ classes.margin }
            >
              <Button
                variant="contained"
                size="small"
                color={ changes > 0 ? "primary" : "default" }
                disabled={ changes <= 0 }
                onClick={ onSave }
              >
                Save
                <SaveIcon className={ classes.bottomButtonIcon } />
              </Button>
            </Badge>
          </div>
        </div>
      </div>
      <div className={ classes.content }>
        { children }
      </div>
    </div>
  )
}

export default QuoteTree

